import { render, staticRenderFns } from "./App.vue?vue&type=template&id=04e65e0a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/components/header-footer.less?vue&type=style&index=0&lang=less&"
import style1 from "@/assets/styles/components/contact-form.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports